import * as Utils from "@/modules/utils";
import * as Debug from "@/modules/debug";
import * as Service from '@/modules/service';
import * as User from '@/modules/user';
import { useRouter } from 'vue-router/dist/vue-router';


let api_token = '';
let api_user_id = 0;
let expiration_timeout = null;


export function Clear ()
{
	sessionStorage.removeItem( 'api_token' );
	sessionStorage.removeItem( 'api_user_id' );
	
	clearTimeout( expiration_timeout );
	
	Debug.Security.Token.Add( 'clear', '' );
}


// Request a new token
export async function Fetch ( email, password )
{
	if ( expiration_timeout )
		clearTimeout( expiration_timeout );
	
	let result = await Service.Send( {
		endpoint: 'auth/login/client',
		use_authorization: false,
		data:
		{
			username: email,
			password: password,
		}
	} );
	
	Service.Show_result_messages( result );
	
	Debug.Console( 'Fetch token', result );
	Debug.Security.Token.Add( 'fetch', JSON.stringify( result ) );
	
	if ( !result?.ok || !result?.ack || !result?.data || !result?.data?.token )
		return Clear();
	
	let digested = Digest( result.data.token );
	let now = ( new Date() ).getTime() / 1000;
	
	Debug.Console( 'Fetch token - digested', digested );
	
	if ( !digested || !digested?.payload || !digested?.payload?.clientId || !digested?.payload?.exp || !( digested?.payload?.exp > now ) )
		return Clear();
	
	sessionStorage.setItem( 'api_token', result.data.token );
	sessionStorage.setItem( 'api_user_id', digested.payload.clientId );
	
	expiration_timeout = setTimeout( Refresh, Get_refresh_timeout_ms( digested.payload.exp ) );
}


export async function Check_refresh ()
{
	if ( expiration_timeout )
		clearTimeout( expiration_timeout );
	
	let token = sessionStorage.getItem( 'api_token' );
	
	if ( !token )
		return Clear();
	
	let digested = Digest( token );
	
	if ( !digested || !digested?.payload || !digested?.payload?.clientId || !digested?.payload?.exp )
		return Clear();
	
	let limit = ( ( new Date() ).getTime() / 1000 ) - 300; // 5 minutos de margen
	
	if ( digested.payload.exp <= limit )
		await Refresh();
}


export function Get_user_id ()
{
	return parseInt( sessionStorage.getItem( 'api_user_id' ) );
}


export function Get ()
{
	return sessionStorage.getItem( 'api_token' );
}


/*******************************************************************/


function Get_refresh_timeout_ms ( expiration )
{
	const margin = 300; // 5 minutos de margen
	let now = ( new Date() ).getTime() / 1000;
	
	return ( expiration - now - margin ) * 1000;
}


function Parse_base64_encoded ( data )
{
	return JSON.parse( Utils.Base64url_decode( data.replace( '-', '+' ).replace( '_', '/' ) ) )
}


function Digest ( token )
{
	// Forzamos la conversión a cadena de texto, para prevenir el error en el split
	let parts = String( token ).split( '.' );
	
	if ( !parts[0] || !parts[1] || !parts[2] )
		return false;
	
	let header = Parse_base64_encoded( parts[0] );
	let payload = Parse_base64_encoded( parts[1] );
	
	if ( !header || !payload )
		return false;
	
	return { header: header, payload: payload, signature: parts[2] };
}


async function Refresh ()
{
	expiration_timeout = null;
	
	let result = await Service.Send( { endpoint: 'auth/refresh-token' } );
	
	Debug.Console( 'Refresh token', result );
	Debug.Security.Token.Add( 'refresh', JSON.stringify( result ) );
	
	if ( !result?.ok || !result?.ack || !result?.data || !result?.data?.token )
	{
		User.Clear();
		Clear();
		
		let router = useRouter();
		await router.replace( { name: 'Login' } );
		
		return;
	}
	
	let digested = Digest( result.data.token );
	let now = ( new Date() ).getTime() / 1000;
	
	Debug.Console( 'Refresh token - digested', digested );
	
	if ( !digested || !digested?.payload || !digested?.payload?.clientId || !digested?.payload?.exp || !( digested?.payload?.exp > now ) )
	{
		User.Clear();
		Clear();
		
		let router = useRouter();
		await router.replace( { name: 'Login' } );
		
		return;
	}
	
	api_token = result.data.token;
	api_user_id = digested.payload.clientId;
	
	expiration_timeout = setTimeout( Refresh, Get_refresh_timeout_ms( digested.payload.exp ) );
}
























/**********************************************************/




export function xSave ( token )
{
	api_token = token;
	localStorage.setItem( 'api_token', api_token );
	
	Debug.Security.Token.Add( 'save', api_token );
}

export function xClear ()
{
	api_token = '';
	localStorage.removeItem( 'api_token' );
}


export function xRecover ()
{
	let saved_token = localStorage.getItem( 'api_token' );
	
	Debug.Security.Token.Add( 'recover', saved_token );
	
	if ( Is_valid( saved_token ) )
	{
		Save( saved_token );
		return true;
	}
	
	return false;
}
